import { NotificationMessage } from "../models/models";
import { ApiErrorDetails, SerializedError } from "../models/errorHandlingModels";

export const serializeError = (error: any): SerializedError => {
  const serverMessage = error.response?.data?.message;
  // `details` reaches us either already flattened by the axios interceptor
  // (`core/api.ts`) or still nested on a raw axios error. Additive — undefined for
  // every error that does not carry one.
  const details: ApiErrorDetails | undefined =
    error.details || error.response?.data?.details;

  return {
    message: serverMessage || error.message || "An error occurred",
    status: error.response?.status || 500,
    code: error.code || "UNKNOWN_ERROR",
    data: error.response?.data || null,
    details,
  };
};

export const createErrorNotification = (serializedError: SerializedError): NotificationMessage => {
  const errorObject = {
    message: serializedError?.message || "An error occurred",
    response: {
      status: serializedError?.status || 500,
      data: serializedError?.data || null,
    },
  };
  return NotificationMessage.error(errorObject);
}; 